module.exports = __webpack_public_path__ + "static/media/gmail.deda33ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gmail.svg
// module id = 15
// module chunks = 0